import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
  Tip,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
} from "grommet-icons";
import axios from "axios";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
} from "./GlobalSettings";
import DocContentDetail from "./DocContentDetail";

class DocListView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      DocContent: this.props._doccontent,
      bShowDocDetail: false,
    };
    this._showDocDetail = this._showDocDetail.bind(this);
    this._hideDocDetail = this._hideDocDetail.bind(this);
  }

  componentDidMount() {}

  _showDocDetail() {
    //console.log("Show dmo Det clicked with data passed as ", data);
    this.setState({ bShowDocDetail: true });
  }
  _hideDocDetail() {
    this.setState({ bShowDocDetail: false });
    this.props.hide();
  }

  render() {
    var DocCont = this.state.DocContent
      ? this.state.DocContent
      : this.props._doccontent;

    var bShowDetailPopup = false;
    bShowDetailPopup = this.state.bShowDocDetail;

    return (
      <Box
        align="center"
        justify="between"
        direction="row-responsive"
        gap="medium"
        responsive={false}
      >
        <Box align="center" justify="start" flex direction="row">
          <Box
            align="center"
            justify="center"
            pad="small"
            background={{ color: "teal" }}
            round="small"
          >
            <DocumentPdf color="black" size="large" />
          </Box>
          <Box
            align="center"
            justify="start"
            direction="row"
            gap="small"
            pad="medium"
          >
            <Box align="stretch" justify="center">
              <Text weight="bold" color="black">
                {DocCont.Content_Title}
              </Text>
              <Text weight="normal" color="black">
                {"Document"}
              </Text>
              <Text weight="normal" color="black">
                {DocCont.Content_ExpertiseLevel
                  ? DocCont.Content_ExpertiseLevel.ExpertLevelName
                  : "No Expertise"}
              </Text>
            </Box>
          </Box>
        </Box>
        <Box
          align="center"
          justify="end"
          direction="row"
          flex={false}
          pad={{ horizontal: "small" }}
          gap="xxsmall"
        >
          <Tip
            plain
            content={
              <Box
                pad="small"
                gap="small"
                width={{ max: "small" }}
                round="small"
                background="background-front"
                responsive={false}
              >
                <Text weight="bold">Details</Text>
                <Text size="small">
                  Click to see details and View or Download Document.
                </Text>
              </Box>
            }
            dropProps={{ align: { left: "right" } }}
          >
            <Button icon={<ScheduleNew />} onClick={this._showDocDetail} />
          </Tip>
          {/* <Button label="view" primary={false} secondary />
          <Button
            label="Download"
            reverse
            secondary={false}
          /> */}
        </Box>
        {bShowDetailPopup && (
          <DocContentDetail
            _docContent={DocCont}
            hide={this._hideDocDetail}
            calledBy={this.props.calledBy}
          />
        )}
      </Box>
    );
  }
}

export default DocListView;
